<template>
  <div
    class="dropzone"
    :class="{
      'dropzone-active': $refs.upload && $refs.upload.dropActive,
    }"
  >
    <h4 v-if="$refs.upload && $refs.upload.dropActive">Loslassen zum Upload</h4>
    <h4 v-else>Bilder hier hineinziehen</h4>

    <p>– oder –</p>

    <file-upload
      :drop="true"
      :multiple="true"
      ref="upload"
      @input-file="handleFile"
    >
      <buttonc label="Dateien auswählen" icon="fa-plus" />
    </file-upload>

    <ul v-if="Object.keys(files).length > 0" class="upload-list">
      <li v-for="(fileData, id) in files" :key="id">
        <span>{{ fileData.f.name }}</span> -
        <span>{{ fileData.f.size | formatSize }}</span>

        <span v-if="fileData.error"> - {{ fileData.error }}</span>

        <p v-if="fileData.sizeWarning">
          <buttonc
            icon="fa-play"
            label="Fortfahren"
            type="green"
            v-on:click="continueSizeCheck(id)"
          />
          <buttonc
            icon="fa-stop"
            label="Abbrechen"
            v-on:click="removeFile(id)"
          />
        </p>

        <bar :min="0" :max="100" :value="fileData.uploadProgress" />
      </li>
    </ul>
  </div>
</template>

<script>
import buttonc from "../uicomponents/button";
import FileUpload from "vue-upload-component";
import axios from "axios";

export default {
  name: "fileUploadBox",
  components: { FileUpload, buttonc },
  props: {
    promotionId: Number,
  },
  data() {
    /**
     * @type {Object.<string,{f: VUFile, error: string, sizeWarning: boolean, uploadProgress: number|null}>} files
     */
    const files = {};
    return { files };
  },
  methods: {
    /**
     * @param {string} fileId
     */
    removeFile(fileId) {
      this.$delete(this.files, fileId);
    },
    /**
     * @param {Blob} blob
     * @returns {Promise<string>} The MimeType of the file, currently supported: image/png, image/jpeg, image/gif; default: unknown
     */
    checkMimeType(blob) {
      return new Promise((res) => {
        var fileReader = new FileReader();
        fileReader.onloadend = function (e) {
          var arr = new Uint8Array(e.target.result).subarray(0, 4);
          var header = "";
          for (var i = 0; i < arr.length; i++) {
            header += arr[i].toString(16);
          }

          // Check the file signature against known types
          switch (header) {
            case "89504e47":
              // "image/png"
              res("image/png");
              break;
            case "47494638":
              // "image/gif";
              res("image/gif");
              break;
            case "ffd8ffe0":
            case "ffd8ffe1":
            case "ffd8ffe2":
            case "ffd8ffe3":
            case "ffd8ffe8":
              // "image/jpeg";
              res("image/jpeg");
              break;
            default:
              // "unknown"; // Or you can use the blob.type as fallback
              if (blob.type.startsWith("image/")) res(blob.type);
              else res("unknown");
              break;
          }
        };
        fileReader.readAsArrayBuffer(blob);
      });
    },
    /**
     * @param {VUFile|null} newFile
     * @param {VUFile|null} oldFile
     */
    async handleFile(newFile, oldFile) {
      if (!newFile) return;

      // Check file size
      if (newFile.size > 32 * 1000 * 1000) {
        this.files = {
          ...this.files,
          [newFile.id]: {
            f: newFile,
            error: `Upload von ${newFile.name} fehlgeschlagen, die Datei ist größer als 32MB`,
            sizeWarning: false,
          },
        };
        return;
      }
      if (newFile.size > 10 * 1000 * 1000) {
        this.files = {
          ...this.files,
          [newFile.id]: {
            f: newFile,
            error: null,
            sizeWarning: true,
          },
        };
        return;
      }

      // Perform MIME Check immediately if file size is < 10 MB
      const mimeType = await this.checkMimeType(newFile.file);
      if (mimeType === "unknown") {
        this.files = {
          ...this.files,
          [newFile.id]: {
            f: newFile,
            error: `Upload von ${newFile.name} fehlgeschlagen, der Dateityp wird nicht unterstützt`,
            sizeWarning: false,
          },
        };
      } else {
        this.files = {
          ...this.files,
          [newFile.id]: {
            f: newFile,
            error: null,
            sizeWarning: false,
          },
        };
        this.uploadFile(newFile).catch((error) => {
          this.files = {
            ...this.files,
            [newFile.id]: {
              ...this.files[newFile.id],
              error: `Upload von ${newFile.name} fehlgeschlagen: ${error.message}`,
            },
          };
        });
      }
    },
    /**
     * @param {string} fileId
     */
    async continueSizeCheck(fileId) {
      const fileToUpload = this.files[fileId];
      const mimeType = await this.checkMimeType(fileToUpload.f.file);
      if (mimeType === "unknown") {
        this.$set(
          fileToUpload,
          "error",
          `Upload von ${fileToUpload.name} fehlgeschlagen, der Dateityp wird nicht unterstützt`
        );
        this.$set(fileToUpload, "sizeWarning", false);
      } else {
        this.$set(fileToUpload, "sizeWarning", false);
        this.$set(fileToUpload, "uploadProgress", 0);
        this.uploadFile(fileToUpload.f).catch((error) => {
          this.$set(
            fileToUpload,
            "error",
            `Upload von ${fileToUpload.name} fehlgeschlagen: ${error.message}`
          );
        });
      }
    },
    /**
     * @param {VUFile} file
     */
    async uploadFile(file) {
      const fileToUpload = this.files[file.id];
      // const companyGroupId = this.$store.state.companyId;

      const formData = new FormData();
      formData.append("promoFile", file.file, file.name);
      formData.append("promotionId", `${this.promotionId}`);

      try {
        const response = await axios.post("/api/sec/files/", formData, {
          headers: {
            Authorization: "Bearer " + this.$store.state.jwt,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            console.log(
              (progressEvent.loaded / progressEvent.total) * 100 + "%"
            );
            this.$set(
              fileToUpload,
              "uploadProgress",
              (progressEvent.loaded / progressEvent.total) * 100
            );
          },
        });
        // TODO: Animate the removal of the file from the upload box and trigger an event to refresh the promotions list
        this.$emit("upload-success", fileToUpload);
        // Remove file after upload or error after 5/10s
        setTimeout(() => {
          this.$delete(this.files, file.id);
        }, 5 * 1000);
      } catch (error) {
        this.$set(
          fileToUpload,
          "error",
          `Upload von ${file.name} fehlgeschlagen: ${error.message}`
        );
        // Remove file when an error occurs after 10s
        setTimeout(() => {
          this.$delete(this.files, file.id);
        }, 10 * 1000);
      }
    },
  },
  filters: {
    formatSize(size) {
      if (size > 1000 * 1000 * 1000 * 1000) {
        return (size / 1000 / 1000 / 1000 / 1000).toFixed(2) + " TB";
      } else if (size > 1000 * 1000 * 1000) {
        return (size / 1000 / 1000 / 1000).toFixed(2) + " GB";
      } else if (size > 1000 * 1000) {
        return (size / 1000 / 1000).toFixed(2) + " MB";
      } else if (size > 1000) {
        return (size / 1000).toFixed(2) + " KB";
      }
      return size.toString() + " B";
    },
  },
};
</script>

<style scoped>
.dropzone {
  width: 100%;
  padding: 2rem 1rem 1rem;
  border: 2px dashed var(--contrast-5);
  background-color: var(--bg);
  transition: border 125ms ease, background-color 125ms ease;
  color: var(--contrast-4);
}

.dropzone-active {
  border-radius: 6px;
  background-color: var(--contrast-1);
}

.upload-list {
  list-style: none;
}

.upload-list li {
  display: flex;
  align-items: center;
}

.upload-list li .bar {
  flex: 100% 1;
}
</style>
